import { MediaImageStandard } from 'components/Contentful'
import { PlayButtonBackground } from '@/components/PlayButtonBackground'
import { Typography } from 'components/Contentful'
import { AchieveLink } from '@/components/AchieveLink'

export const DebtSolutionsArticleCard = ({ title, slug, mainImage, hook, author, id }) => {
  return (
    <>
      <div className="max-w-[336px] max-h-[478px]">
        <AchieveLink
          href={slug}
          track={{
            list_name: `ARTICLE LINK`,
            position: id,
            click_id: `Achieve Web | ${title}`,
            click_text: title,
            click_url: slug,
            nav_link_section: 'Article',
            track_event: 'link_click',
            click_type: 'Link Click',
            event_action: 'link_click',
            event_type: 'link_click',
          }}
          className={'text-black hover:no-underline hover:data-[testid="card-title"]:underline'}
          underline="hover"
          data-testid="article-card-link"
        >
          <div>
            {mainImage && (
              <div>
                <div
                  className={
                    'relative max-h-full max-w-full w-[336px] h-[206px] [&_span]:box-border [&_span]:block [&_span]:overflow-hidden [&_span]:w-[initial] [&_span]:h-[initial] [background:none] [&_span]:opacity-100 [&_span]:absolute [&_span]:m-0 [&_span]:p-0 [&_span]:border-0 [&_span]:inset-0 [&_img]:absolute [&_img]:box-border [&_img]:block [&_img]:w-0 [&_img]:h-0 [&_img]:min-w-full [&_img]:max-w-full [&_img]:min-h-full [&_img]:max-h-full [&_img]:object-cover [&_img]:m-auto [&_img]:p-0 [&_img]:border-[none] [&_img]:inset-0 md:w-[336px] md:h-[206px] [&_img]:object-[center_center] [&_img]:rounded-[12px]'
                  }
                >
                  <MediaImageStandard layout="cover" content={mainImage.mediaContent} />
                  {mainImage?.__typename !== 'MediaField' && <PlayButtonBackground fontSize={64} />}
                </div>
              </div>
            )}

            {title && (
              <Typography
                content={title}
                component="h3"
                className={'bodyLg lg:headingMd font-bold my-3 mx-0'}
                fontWeight="bold"
                data-testid="card-title"
              />
            )}
            {hook && (
              <Typography
                content={hook}
                variant={'bodySm'}
                className={'flex flex-col max-w-[315px]'}
                fontWeight="regular"
                data-testid="card-text"
              />
            )}
          </div>
        </AchieveLink>
        <div className="flex flex-row mt-[14px]">
          <MediaImageStandard
            alt={author.authorName}
            className={'rounded-[40px]'}
            content={author.authorPhoto}
            layout="fixed"
            height={40}
            width={40}
            data-testid="press-article-author-headshot"
          />
          <div className="flex flex-col ml-[9px]">
            <Typography className="text-[14px] font-medium" content={author.authorName} />
            <Typography className="text-[14px] text-[#42546B]" content={'Author'} />
          </div>
        </div>
      </div>
    </>
  )
}
